import React from 'react';

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Đang tải...' }) => {
  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center bg-slate-50 font-sans">
      {/* Animated Background Blobs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] bg-gradient-to-br from-blue-400 to-purple-500 rounded-full blur-3xl opacity-40 animate-float-slow mix-blend-multiply"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] bg-gradient-to-br from-pink-400 to-orange-400 rounded-full blur-3xl opacity-40 animate-float-medium mix-blend-multiply"></div>
        <div className="absolute top-[30%] left-[20%] w-[50%] h-[50%] bg-gradient-to-br from-teal-300 to-cyan-400 rounded-full blur-3xl opacity-30 animate-float-fast mix-blend-multiply"></div>
      </div>

      {/* Loading Spinner */}
      <div className="flex flex-col items-center relative z-10">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mb-4 shadow-lg"></div>
        <p className="text-slate-500 font-medium">{message}</p>
      </div>
    </div>
  );
};
